var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center text-xs md:text-sm w-full"},[(_vm.$store.state.showGradient)?_c('div',{staticClass:"bg-gradient-to-b from-blue-300 fixed top-0 left-0 h-full w-full z-back"}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }